import {
    PAYMENT_OPTIONS,
    GENDER_MAP,
    RELATIONSHIP_MAP,
    ETHNICITY_OPTIONS,
    RACE_OPTIONS,
    LANGUAGE_OPTIONS,
    MATERIALS_FOR_PRINTED_COPY,
} from 'components/EnrollmentV2/constants/selectOptions';
import { PAY_OPTION, YES_NO_OPTION } from '../constants/enum';
import { isNil } from 'lodash';

const translateBool = (value) => {
    switch (parseInt(value)) {
        case YES_NO_OPTION['Yes']:
            return 'Yes';
        case YES_NO_OPTION['No']:
            return 'No';
        case YES_NO_OPTION['Not Sure']:
            return 'Not Sure';
        default:
            return 'N/A';
    }
};
const translateRelation = (value) => {
    if (value) {
        const relationshipValue = parseInt(value);
        for (const [name, optionValue] of Object.entries(RELATIONSHIP_MAP)) {
            if (optionValue === relationshipValue) {
                return name;
            }
        }
    }
    return '';
};
const translatePayment = (value) => {
    switch (parseInt(value)) {
        case PAY_OPTION.RECEIVE_BILL:
            return 'Get a Bill';
        case PAY_OPTION.DEDUCT_FROM_CHECK:
            return 'Automatic deduction from your monthly Social Security or Railroad Retirement Board (RRB) benefit check. (The Social Security/RRB deduction may take two or more months to begin after Social Security or RRB approves the deduction. In most cases, if Social Security or RRB accepts your request for automatic deduction, the first deduction from your Social Security or RRB benefit check will include all premiums due from your enrollment effective date up to the point withholding begins. If Social Security or RRB does not approve your request for automatic deduction, we will send you a paper bill for your monthly premiums.)';
        default:
            break;
    }
    return;
};
const translateGender = (value) => {
    if (!isNil(value)) {
        const genderEnumValue = parseInt(value);
        for (const [name, optionValue] of Object.entries(GENDER_MAP)) {
            if (optionValue === genderEnumValue) {
                return name;
            }
        }
    }
    return '';
};
const translateGenderToIntString = (value) => {
    let option;
    if (!value) {
        return option;
    }
    switch (value.toLowerCase().trim()) {
        case 'male':
            option = GENDER_MAP['Male'].toString();
            break;
        case 'female':
            option = GENDER_MAP['Female'].toString();
            break;
        case 'i use a different term':
            option = GENDER_MAP['I use a different term'].toString();
            break;
        case 'non binary':
            option = GENDER_MAP['Non Binary'].toString();
            break;
        case 'i choose not to answer':
            option = GENDER_MAP['I choose not to answer'].toString();
            break;
        default:
            break;
    }
    return option;
};
const translateStringToYesNoOption = (value) => {
    let option;
    if (!value) {
        return option;
    }
    switch (value.toLowerCase().trim()) {
        case 'yes':
            option = YES_NO_OPTION['Yes'].toString();
            break;
        case 'no':
            option = YES_NO_OPTION['No'].toString();
            break;
        case 'not sure':
            option = YES_NO_OPTION['Not Sure'].toString();
            break;
        default:
            break;
    }
    return option;
};

const translateStringToPaymentOptionsValue = (value) => {
    let paymentOption;
    if (!value) {
        return paymentOption;
    }
    const result = PAYMENT_OPTIONS.filter(
        (option) => cleanText(option.salesForceMatch) === cleanText(value)
    );
    if (result.length > 0) {
        paymentOption = result[0].value;
    }
    return paymentOption;
};
const translateStringLanguageToInt = (value) => {
    if (value) {
        const lowerCaseLanguages = LANGUAGE_OPTIONS.map((option) =>
            option.toLowerCase().trim()
        );
        return lowerCaseLanguages.indexOf(value.toLowerCase().trim()) + 1;
    }
};
const translateEthnicityToValues = (text) => {
    return getArrayItemsByText(ETHNICITY_OPTIONS, text)
        ?.map(({ value }) => value)
        .join(',');
};
const translateRaceToValues = (text) => {
    return getArrayItemsByText(RACE_OPTIONS, text)
        ?.map(({ value }) => value)
        .join(',');
};
const translateStringToCheckBoxName = (text) => {
    const matchingMaterials = getArrayItemsByText(
        MATERIALS_FOR_PRINTED_COPY,
        text
    );
    return matchingMaterials?.map((option) => {
        return option.name;
    });
};

const getArrayItemsByText = (arrayItems, text) => {
    if (text) {
        const textInArray = text.split(';').map((option) => {
            return cleanText(option);
        });
        return arrayItems.filter((option) => {
            return textInArray.some((value) => {
                return cleanText(option.label) === value;
            });
        });
    }
};
const cleanText = (text) => {
    return text.replace(/[^0-9a-z]/gi, '').toLowerCase();
};

export {
    translateBool,
    translatePayment,
    translateRelation,
    translateGender,
    translateStringToYesNoOption,
    translateStringToPaymentOptionsValue,
    translateGenderToIntString,
    translateEthnicityToValues,
    translateRaceToValues,
    translateStringLanguageToInt,
    translateStringToCheckBoxName,
};
